exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-KeywordsSection-KeywordList-header{color:#15284b}.src-components-shared-KeywordsSection-KeywordList-keywordContainer img{max-width:100%}.src-components-shared-KeywordsSection-KeywordList-keyword{color:#ad1f2c;vertical-align:middle}", ""]);

// exports
exports.locals = {
	"header": "src-components-shared-KeywordsSection-KeywordList-header",
	"keywordContainer": "src-components-shared-KeywordsSection-KeywordList-keywordContainer",
	"keyword": "src-components-shared-KeywordsSection-KeywordList-keyword"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/KeywordsSection/KeywordList/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/KeywordsSection/KeywordList/styles.scss
// module chunks = 1